import { render, staticRenderFns } from "./MoveShot.vue?vue&type=template&id=0c8880ea&scoped=true&"
import script from "./MoveShot.vue?vue&type=script&lang=js&"
export * from "./MoveShot.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MoveShot.vue?vue&type=style&index=0&id=0c8880ea&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c8880ea",
  null
  ,true
)

export default component.exports